export class EvaluationService {
  constructor(
    store,
    router,
    paramsCreator,
    retriever,
    saver,
    ratifier,
    dataProcessor
  ) {
    this.retriever = retriever;
    this.saver = saver;
    this.paramsCreator = paramsCreator;
    this.ratifier = ratifier;
    this.store = store;
    this.router = router;
    this.dataProcessor = dataProcessor;
  }

  async saveManualEvaluation(paramsEvaluation) {
    try {
      const dataEvaluation = this.paramsCreator.createEvaluationParams(paramsEvaluation);
      const evaluationId = await this.saver.saveManualEvaluation(dataEvaluation);
      this.store.commit('evaluation/setManualEvaluationId', evaluationId);
    } catch (error) {
      throw new Error(`No se pudo guardar la evaluación ${error.message}`);
    }
  }

  async loadData(evaluationId, onMounted = true, type = 'manual') {
    const evaluation = await this.retriever.getEvaluationData(evaluationId);
    const debtor = await this.retriever.getDebtorData(evaluation.idNumber);
    const reports = debtor.reports || [];
    let evaluationIdForSimulation = evaluationId;
    let typeForSimulation = type;

    if (onMounted) {
      const lastEvaluation = await this.retriever.getLastEvaluation(debtor.idNumber);
      evaluationIdForSimulation = lastEvaluation.evaluationId;
      typeForSimulation = lastEvaluation.type;
    }

    const simulationData = await this.retriever.getSimulationData(evaluationIdForSimulation, typeForSimulation);
    const userId = this.store.state.currentUser.user._id;

    const initialData = this.paramsCreator.createInitialData(debtor.idNumber, evaluationId, simulationData, userId);

    this.dataProcessor.commitInitialData(initialData);

    return {
      evaluation,
      debtor,
      reports
    };
  }

  async ratify(manualEvaluationId, parentEvaluationId) {
    return this.ratifier.ratify(manualEvaluationId, parentEvaluationId);
  }

  async getSimulation(evaluationId, type = 'manual') {
    const simulationData = await this.retriever.getSimulationData(evaluationId, type);
    const simulation = this.paramsCreator.createSimulationParams(simulationData);
    this.dataProcessor.commitSimulation(simulation);
  }

  async getDebtor(idNumber) {
    const debtor = await this.retriever.getDebtorData(idNumber);
    this.dataProcessor.commitDebtor(debtor);
  }

  async getEvaluation(evaluationId) {
    return this.retriever.getEvaluationData(evaluationId);
  }
}
